module.exports = __webpack_public_path__ + "static/media/A-Z_1.d2a365c2.png";